import React from "react";
import { WrapWordList, WrapWord, WrapWordText, WrapSettings, Word, SelectWord, SelectTimePoint, PointTime } from './Style'
import { WordsData } from "./hooks";
import { IconButton } from "components/Form";
import { isArray } from "lodash";
import { wordHooks } from ".";
import { colorSettings } from "./hooks/constants";

const WordSettings = (props) => {
    const settingsItems = wordHooks.useSettingsItems()
    const setCheckingStatus = wordHooks.useSetCheckingStatus()
    const markerTypes = wordHooks.useMarkerTypes()
    const { word, index, settings = {}, settingsValues = {} } = props

    const getColor = (key, val) => {
        const basicColor = "gray"

        if (val)
            return colorSettings[key]
        return basicColor
    }

    const getValue = (keys) => {
        if (isArray(keys)) {
            for (let i = 0; i < keys.length; i++) {
                if (settingsValues?.[keys[i]])
                    return { value: settingsValues[keys[i]], key: keys[i] }
            }
            return { value: settingsValues[keys[0]], key: keys[0] }
        }
    }

    return (
        <WrapSettings>
            {settings?.marker?.hide ||
                <div className="wrap-checking-status">
                    <div className={`checking-status link ${word.marker_type} ${word.unread_response && 'bold-question'}`} onClick={() => setCheckingStatus(index)}>
                        {markerTypes[word.marker_type || "default"].icon}
                    </div>
                </div>}
            {settingsItems.map((settingItem, indexKey) => {
                const { wrap, props, button, icon, keys } = settingItem
                const { value, key } = getValue(keys)
                const color = getColor(key, value)
                const disabled = settings[key]?.disabled

                const commonState = {
                    color: color,
                    value: value,
                    disabled: disabled
                }
                const { hide, hideEmpty } = settings[key] || {}
                let hideSetting = false
                if (hide) hideSetting = hide
                else if (hideEmpty && !value) hideSetting = true

                if (!hideSetting)
                    return (
                        <SelectWord {...wrap} key={indexKey}>
                            {settingItem.component ?
                                <settingItem.component
                                    {...props}
                                    {...commonState}
                                    onChange={(val) => props.action(val, word.word_def_id)}
                                />
                                :
                                <IconButton
                                    {...button}
                                    {...commonState}
                                    action={() => button.action(index, word.word_def_id)}
                                    onDoubleClick={() => button?.dblClick && button.dblClick(index, word.word_def_id)}
                                    icon={
                                        <settingItem.icon.name
                                            color={color}
                                            {...icon}
                                        />}
                                />
                            }
                        </SelectWord>
                    )
            }
            )}
        </WrapSettings>
    )
}

export default WordSettings